export default function getPossibleSeasons(community) {
  return {
    test: [
      {
        name: "RePLAY",
        _id: "replay",
        year: "2020/2021",
        acceptRules:
          "https://bucket-gw-cni-static-cms-si.s3.amazonaws.com/media/filer_public/26/16/2616ffaa-0fdd-4be0-ad54-1cd46694cebf/guia_do_desafio.pdf",
      },
      {
        name: "Into Orbit",
        _id: "into_orbit",
        year: "2018/2019",
        acceptRules:
          "https://bucket-gw-cni-static-cms-si.s3.amazonaws.com/media/filer_public/26/16/2616ffaa-0fdd-4be0-ad54-1cd46694cebf/guia_do_desafio.pdf",
      },
      {
        name: "Natures Fury",
        _id: "natures_fury",
      },
    ],
    "fll-brasil": [
      {
        name: "Cargo Connect",
        _id: "cargo_connect",
        year: "2021/2022",
        acceptRules: "https://link.layers.education/regulamento_fll",
      },
      {
        name: "RePLAY",
        _id: "replay",
        year: "2020/2021",
        acceptRules: "https://link.layers.education/regulamento_fll",
      },
      {
        name: "City Shaper",
        _id: "city_shaper",
        year: "2019/2021",
        acceptRules: "https://link.layers.education/regulamento_fll",
      },
      {
        name: "Into Orbit",
        _id: "into_orbit",
        year: "2018/2019",
      },
      {
        name: "Natures Fury",
        _id: "natures_fury",
      },
      {
        name: "Super Powered",
        _id: "super_powered",
      },
      {
        name: "MASTERPIECE℠",
        _id: "masterpiece",
        year: "2023/2024",
        acceptRules: "https://layers.land/fll-regulamento",
      },
      {
        name: "SUBMERGED℠",
        _id: "submerged",
        year: "2024/2025",
        acceptRules: "https://layers.land/fll-regulamento",
      },
      {
        name: "UNEARTHED℠",
        _id: "unearthed",
        year: "2025/2026",
        acceptRules: "https://layers.land/fll-regulamento",
      },
    ],
    "ftc-brasil": [
      {
        name: "Skystone",
        _id: "skystone",
        year: "2019/2020",
        acceptRules:
          "https://bucket-gw-cni-static-cms-si.s3.amazonaws.com/media/filer_public/aa/3e/aa3ea542-85ac-49db-8c37-72398f84c6a6/1_pt_pdf_manual_ftc_-_parte_1.pdf",
      },
      {
        name: "Ultimate Goal",
        _id: "ultimate_goal",
        year: "2020/2021",
        acceptRules:
          "https://bucket-gw-cni-static-cms-si.s3.amazonaws.com/media/filer_public/5b/1d/5b1d8301-393e-4eb9-9d19-3b8565b7ef81/manual_do_jogo_parte_1_-_eventos_tradicionais_completo.pdf",
      },
      {
        name: "Freight Frenzy",
        _id: "freight_frenzy",
        year: "2021/2022",
        acceptRules: "https://link.layers.education/ftc-regulamento",
      },
      {
        name: "Power Play",
        _id: "power_play",
        year: "2022/2023",
        acceptRules: "https://link.layers.education/ftc-regulamento",
      },
      {
        name: "Off Season 2023",
        _id: "off_season_2023",
        year: "2023",
        acceptRules: "https://link.layers.education/ftc-regulamento",
      },
      {
        name: "CENTERSTAGE℠",
        _id: "centerstage",
        year: "2023",
        acceptRules: "https://link.layers.education/ftc-regulamento",
      },
      {
        name: "INTO THE DEEP℠",
        _id: "into_the_deep",
        year: "2024",
        acceptRules: "https://layers.land/ftc-regulamento",
      },
      {
        name: "DECODE℠",
        _id: "decode",
        year: "2025",
        acceptRules: "https://layers.land/ftc-regulamento",
      },
    ],
    "frc-brasil": [
      {
        name: "Off Season FRC",
        _id: "off_season_FRC",
        year: "2021/2022",
        acceptRules: "https://link.layers.education/frc_regulamento",
      },
      {
        name: "Charged Up",
        _id: "charged_up",
        year: "2022/2023",
        acceptRules: "https://link.layers.education/frc_regulamento",
      },
      {
        name: "Off Season 2023",
        _id: "off_season_2023",
        year: "2023",
        acceptRules: "https://link.layers.education/ftc-regulamento",
      },
      {
        name: "CRESCENDO℠",
        _id: "crescendo",
        year: "2023",
        acceptRules: "https://link.layers.education/ftc-regulamento",
      },
      {
        name: "REEFSCAPE℠",
        _id: "reefscape",
        year: "2024",
        acceptRules: "https://layers.land/frc-regulamento",
      },
      {
        name: "REBUILT℠",
        _id: "rebuilt",
        year: "2025",
        acceptRules: "https://layers.land/frc-regulamento",
      },
    ],
    "f1-brasil": [
      {
        name: "2019/2020",
        _id: "2019/2020",
        year: "2019/2020",
        acceptRules:
          "https://bucket-gw-cni-static-cms-si.s3.amazonaws.com/media/filer_public/63/7e/637ef8cd-a890-4a4f-a028-c1f4dc1a4b78/f1_in_schools_2019_world_finals_regras_da_competicao_traduzido.pdf",
      },
      {
        name: "2020/2021",
        _id: "2020/2021",
        year: "2020/2021",
        acceptRules: "https://link.layers.education/f1_regulamento_competicao",
      },
      {
        name: "2021/2022",
        _id: "2021/2022",
        year: "2021/2022",
        acceptRules: "https://link.layers.education/f1_regulamento_competicao",
      },
      {
        name: "2022/2023",
        _id: "2022/2023",
        year: "2022/2023",
        acceptRules:
          "https://static.portaldaindustria.com.br/media/filer_public/b4/5e/b45e8b78-703e-4e32-9606-69481598d5c4/regulamento_da_competicao_2022__portugues.pdf",
      },
      {
        name: "Off Season 2023",
        _id: "off_season_2023",
        year: "2023",
        acceptRules: "https://link.layers.education/ftc-regulamento",
      },
      {
        name: "2023/2024",
        _id: "2024",
        year: "2024",
        acceptRules: "https://layers.land/f1-regulamento",
      },
      {
        name: "2025",
        _id: "2025",
        year: "2025",
        acceptRules: "https://layers.land/f1-regulamento",
      },
      {
        name: "2026",
        _id: "2026",
        year: "2026",
        acceptRules: "https://layers.land/f1-regulamento",
      },
    ],
    desafiocovid: [
      {
        name: "2020",
        _id: "2020",
        year: "2020",
        acceptRules:
          "https://bucket-gw-cni-static-cms-si.s3.amazonaws.com/media/filer_public/68/90/6890a34b-0474-4714-9c81-7cb47b5b6997/desafio_sesi_de_robotica_covid_19.pdf",
      },
    ],
    desafiorelampago: [
      {
        name: "2020",
        _id: "2020",
        year: "2020",
        acceptRules: "https://link.tenda.digital/desafiorelampago/regulamento",
      },
    ],
    "fll-open-brazil": [
      {
        name: "Cargo Connect",
        _id: "cargo_connect",
        year: "2021/2022",
        acceptRules: "https://link.tenda.digital/desafiorelampago/regulamento",
      },
    ],
    "off-season-sesi-mt": [
      {
        name: "Off Season MT",
        _id: "off_season",
        year: "2024",
        acceptRules: "https://link.layers.education/regulamento_fll",
      },
    ],
  }[community];
}



// WEBPACK FOOTER //
// ./src/helpers/events/getPossibleSeasons.js